import React, { useState, useEffect, useRef } from "react";
import { SendIcon } from "../shared/icons";
import { useNavigate } from "react-router-dom";

const VideoSearch: React.FC = () => {
  const navigate = useNavigate();
  const [destination, setDestination] = useState("");
  const containerRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLParagraphElement>(null);
  const formRef = useRef<HTMLFormElement>(null);
  const [titleVisible, setTitleVisible] = useState(false);
  const [formVisible, setFormVisible] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => setTitleVisible(true), 0);
            setTimeout(() => setFormVisible(true), 150);
            observer.unobserve(containerRef.current!);
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(containerRef.current);
      return () => observer.disconnect();
    }
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (destination.trim() === "") {
      return;
    }
    navigate(`/videopage?tags=${destination}`, {
      state: { videoSearchDestination: destination },
    });
  };

  return (
    <>
      <div
        ref={containerRef}
        className="text-white w-full flex flex-col justify-center px-8 2xl:px-40 xl:px-24 lg:px-14 mb-10"
      >
        <p
          ref={titleRef}
          className={`md:text-[24px] text-xl xl:text-[28px] font-bold lg:mb-6 mb-4 fade-in-section ${
            titleVisible ? "fade-in-visible" : ""
          }`}
        >
          Travel videos
        </p>
        <form
          ref={formRef}
          autoComplete="off"
          onSubmit={handleSubmit}
          className={`w-full flex items-center gap-x-2 bg-white rounded-full xl:w-[60%] lg:w-[70%] md:max-w-[80%] sm:max-w-[90%] fade-in-section ${
            formVisible ? "fade-in-visible" : ""
          }`}
        >
          <input
            type="text"
            value={destination}
            onChange={(e) => setDestination(e.target.value)}
            className="w-full lg:px-5 xl:px-7 px-5 md:py-[18px] py-4 lg:py-4 xl:py-5 rounded-full outline-none font-semibold lg:text-lg xl:text-xl text-base text-black placeholder:text-[#898989]"
            placeholder="Ask me any travel idea!"
          />
          <button
            type="submit"
            disabled={!destination.trim()}
            // className=""

            className={`md:mr-2 mr-1.5 flex-shrink-0 bg-[#181818] rounded-full lg:p-2.5 xl:p-4 p-2 relative ${
              !destination.trim() ? "opacity-70 cursor-not-allowed" : ""
            }`}
          >
            {!destination.trim() ? (
              <>
                <span className="xl:scale-150 lg:scale-125 flex items-center justify-center opacity-50">
                  <SendIcon />
                </span>
              </>
            ) : (
              <span className="xl:scale-150 lg:scale-125 flex items-center justify-center">
                <SendIcon />
              </span>
            )}
          </button>
        </form>
      </div>
    </>
  );
};

export default VideoSearch;
